import React, {ComponentType, useState, useEffect} from 'react';
import {useSelector} from 'react-redux';
import {Role} from '../dto/UserDto';
import {authSelector} from './selectors';
import NotFound from '../modules/not-found';

export default (ComposedComponent: ComponentType<{}>, needRoles: Role[]) => {
    const Authenticate = () => {
        const [isAuth, setIsAuth] = useState(true);
        const {user} = useSelector(authSelector);

        useEffect(() => {
            const found = user?.roles.some((role) => needRoles.includes(role));
            setIsAuth(Boolean(found));
        }, [user]);

        return isAuth ? <ComposedComponent /> : <NotFound />;
    };

    return Authenticate;
};
